import { autoinject } from "aurelia-dependency-injection";
import { MepPortTrafficActualEmissionsItem, MepPortTrafficActualEmissionsRequest, MepPortTrafficForecastEmissionsItem } from "../../../../../../../../models/mep/mep-scenario-planning.models";
import { MepScenarioPlanningSerivce } from "../../../../../../../../services/mep/mep-scenario-planning.service";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/modules/mep/tabs/mep-scenario-planning/partials/mep-scenario-planning-port-traffic/mep-scenario-planning-port-traffic.html')
export class MepScenarioPlanningPortTraffic {

    public baselineYear: number;
    public forecastYear: number;
    public items: MepPortTrafficActualEmissionsItem[] = [];
    public forecastItems: MepPortTrafficForecastEmissionsItem[] = [];

    constructor(private mepScenarioPlanningSerivce: MepScenarioPlanningSerivce) {
    }

    public loadData(request: MepPortTrafficActualEmissionsRequest, forecastYear: number): Promise<string> {
        if (request) {
            this.baselineYear = request.baselineYear;
        }

        return new Promise<string>((resolve, reject) => {
            this.forecastYear = forecastYear;
            if (request) {
                this.mepScenarioPlanningSerivce.getMepPortTrafficActualEmissionsByVesselType(request).then(response => {
                    this.items = response.items;

                    this.forecastItems = [];
                    this.items.forEach(item => {
                        this.forecastItems.push(new MepPortTrafficForecastEmissionsItem(item));
                    });

                    resolve(null);
                }).catch(() => {
                    reject(`MEP scenario planning port traffic actual emissions by vessel type - Error retrieving the data!`);
                });
            }
        });
    }

    get totalPortCalls() {
        if (this.items.length > 0) {
            return this.items.reduce((total, number) => total + number.vesselCallsTugboatJobs, 0);
        }
    }

    get totalForecastPortCalls() {
        if (this.forecastItems.length > 0) {
            return this.forecastItems.reduce((total, number) => total + number.vesselCallsTugboatJobs, 0);
        }
    }

    get totalEmissionsQtyTonnes() {
        if (this.items.length > 0) {
            return this.items.reduce((total, number) => total + number.averageEmissionsInKgPerHour * number.averageTimeInPortInDays * 24 * number.vesselCallsTugboatJobs / 1000, 0);
        }
    }

    get totalForecastEmissionsQtyTonnes() {
        if (this.forecastItems.length > 0) {
            return this.forecastItems.reduce((total, number) => total + number.averageEmissionsInKgPerHour * number.averageTimeInPortInDays * 24 * number.vesselCallsTugboatJobs / 1000, 0);
        }
    }

    get totalPortCallPercentageDifference() {
        if (this.totalPortCalls == 0) {
            return 0;
        }

        return 100 * (this.totalForecastPortCalls - this.totalPortCalls) / this.totalPortCalls;
    }

    get totalPortCallPercentageDifferenceWholeNumber() {
        return Math.floor(Math.abs(this.totalPortCallPercentageDifference)) * (this.totalPortCallPercentageDifference < 0 ? -1 : 1);
    }

    get totalPortCallPercentageDifferenceDecimal() {
        return (Math.abs(this.totalPortCallPercentageDifference - this.totalPortCallPercentageDifferenceWholeNumber)) * 10;
    }

    get totalEmissionsPercentageDifference() {
        if (this.totalEmissionsQtyTonnes == 0) {
            return 0;
        }

        return 100 * (this.totalForecastEmissionsQtyTonnes - this.totalEmissionsQtyTonnes) / this.totalEmissionsQtyTonnes;
    }

    get totalEmissionsPercentageDifferenceWholeNumber() {
        return Math.floor(Math.abs(this.totalEmissionsPercentageDifference))* (this.totalEmissionsPercentageDifference < 0 ? -1 : 1)
    }

    get totalEmissionsPercentageDifferenceDecimal() {
        return (Math.abs(this.totalEmissionsPercentageDifference - this.totalEmissionsPercentageDifferenceWholeNumber)) * 10;
    }
}